import { NgModule } from '@angular/core';
import { SearchComponent } from './search.component';
import { SharedProviderModule } from '../../shared/shared.module';
import { OverlayPanelModule } from '../overlay-panel/overlay-panel.module';
import { VrgroupModule } from '../../custom/vrgroup/vrgroup.module';
import { QmDirectivesModule } from '../qm-directives/qm-directives.module';
import { QmPipesModule } from '../qm-pipes/qm-pipes.module';
import { ElementInfoModule } from '../../element-info/element-info.module';
import { ElementUtilsModule } from '../../element-utils/element-utils.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    ElementInfoModule,
    ElementUtilsModule,
    SharedProviderModule,
    OverlayPanelModule,
    ClickOutsideModule,
    VrgroupModule,
    QmDirectivesModule,
    QmPipesModule,
    NgbTooltipModule
  ],
  declarations: [SearchComponent],
  exports: [SearchComponent]
})
export class SearchModule {
}
